// extracted by mini-css-extract-plugin
export default {"body":"SingleReport_body__Axkar","bodyContainer":"SingleReport_bodyContainer__hhWqd","container":"SingleReport_container__s2Cq5"};